import { Component, EventEmitter, OnInit, Input, Output, forwardRef, ViewChild, ViewChildren, QueryList, SimpleChanges } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem, InputMask } from 'primeng/primeng';
import * as _ from "lodash";

//constants

//validators
import { dropDownValidator, emailValidatorWithParameters, phoneNumberValidatorWithParameters } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';
import { emailValidator } from '../../validators/CustomValidators';
import { phoneRequiredValidator } from '../../validators/CustomValidators';

//components
import { CustomersAutoCompleteComponent } from '../../components/Customers/CustomersAutoComplete.component';
import { EmployeeDropdownComponent } from '../../components/Employees/EmployeeDropdown.component';
import { BusinessTypeDropdownComponent } from '../../components/DomainData/BusinessTypeDropdown.component';
import { OutletAcquisitionTypeDropdownComponent } from '../DomainData/OutletAcquisitionTypeDropdown.component';
import { ProspectSourceDropdownComponent } from '../DomainData/ProspectSourceDropdown.component';
import { CustomerTypeDropdownComponent } from '../../components/DomainData/CustomerTypeDropdown.component';
import { EmployeesAutoCompleteComponent } from '../../components/Employees/EmployeesAutoComplete.component';
import { RequestCustomerGridComponent } from '../../components/Grids/RequestCustomerGrid.component';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';
import { YesNoDropdownComponent } from '../DomainData/YesNoDropdown.component';

@Component({
    selector: 'my-generaldetails',
    templateUrl: './GeneralDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => GeneralDetailsComponent) }]
})
export class GeneralDetailsComponent extends BaseControlGroupComponent {

    generalDetailsForm: FormGroup;
    generalInfo: ent.GeneralInfo = new ent.GeneralInfo();
    selectedCustomer: ent.Customer;
    serialNumbers: ent.SerialNumber[] = [];
    disableEquipmentInstall: boolean=false;
    disableOwnershipChange: boolean=false;

    employeeAutoCompleteComponent: EmployeesAutoCompleteComponent;
    oldZRPartnerEmployeeAutoCompleteComponent: EmployeesAutoCompleteComponent;
    oldZKPartnerEmployeeAutoCompleteComponent: EmployeesAutoCompleteComponent;
    reportingHierarchyEmployeeAutoCompleteComponent: EmployeesAutoCompleteComponent;

    disableCustomersAutocomplete: boolean;

    @ViewChildren(EmployeesAutoCompleteComponent) employeesAutoCompleteComponents: QueryList<EmployeesAutoCompleteComponent>;
    @ViewChild('customersAutoComplete') public customersAutoCompleteComponent: CustomersAutoCompleteComponent;
    @ViewChild('customerAutoComplete') public customerAutoCompleteComponent: CustomersAutoCompleteComponent;
    @ViewChild('existingCustomerAutoComplete') public existingCustomerAutoCompleteComponent: CustomersAutoCompleteComponent;
    @ViewChild(BusinessTypeDropdownComponent) public businessTypeDropdownComponent: BusinessTypeDropdownComponent;
    @ViewChild(CustomerTypeDropdownComponent) public customerTypeDropdownComponent: CustomerTypeDropdownComponent;
    @ViewChild(RequestCustomerGridComponent) public requestCustomerGridComponent: RequestCustomerGridComponent;
    @ViewChild('willCustomerSellDrPepper') public willCustomerSellDrPepperDropdownComponent: YesNoDropdownComponent;
    @ViewChild('OutletAcquisitionTypeDropdownComponent') public OutletAcquisitionTypeDropdownComponent: OutletAcquisitionTypeDropdownComponent;
    @ViewChild('ProspectSourceDropdownComponent') public ProspectSourceDropdownComponent: ProspectSourceDropdownComponent;

    @Output() public includeSurveyRequestChanged: EventEmitter<boolean> = new EventEmitter();
    @Output() public includeEquipmentInstallChanged: EventEmitter<boolean> = new EventEmitter();
    @Output() public includeOwnershipChangeChanged: EventEmitter<boolean> = new EventEmitter();

    @Output() public businessTypeChanged: EventEmitter<number> = new EventEmitter();
    @Output() public customerTypeChanged: EventEmitter<number> = new EventEmitter();
    @Output() public customerNumberChanged: EventEmitter<string> = new EventEmitter();
    @Output() public onBusinessTypeLoadDone: EventEmitter<any> = new EventEmitter();

    @Input() public overrideEmployeeLabel: string;

    @Input() public showCustomerNumber: boolean;
    @Input() public customerNumberInfoLabel: string;
    @Input() public customerNumbersInfoLabel: string;
    @Input() public showCustomersAutoSelect: boolean;
    @Input() public showOldZRPartnerEmployee: boolean;
    @Input() public showOldZKPartnerEmployee: boolean;
    @Input() public showReportingHierarchyEmployee: boolean;
    @Input() public showEmployee: boolean;
    @Input() public showBusinessName: boolean;
    @Input() public showStoreNumber: boolean;
    @Input() public showLegalName: boolean;
    @Input() public showLanguage: boolean;
    @Input() public showOverallAccountPhoneNumber: boolean;
    @Input() public showFax: boolean;
    @Input() public showEmail: boolean;
    @Input() public showCMA: boolean;
    @Input() public showProjectNumber: boolean;
    @Input() public showVendingMachineLocation: boolean;
    @Input() public showSubtradeChannel: boolean;
    @Input() public showBusinessType: boolean;
    @Input() public showIncludeEquipmentInstall: boolean;
    @Input() public showIncludeSurveyRequest: boolean;
    @Input() public showCustomerNumbers: boolean;
    @Input() public showCustomerType: boolean;
    @Input() public showIncludeOwnershipChange: boolean;
    @Input() public showChangeCustomerToSecondaryVolume: boolean;
    @Input() public showWillCustomerSellDrPepper: boolean;
    @Input() public showAllCustomersCheckbox: boolean;
    @Input() public showNewBusinessName: boolean;
    @Input() public showNewLegalName: boolean;
    @Input() public showCustomerPayer: boolean;
    @Input() public showSalesOffice: boolean;
    @Input() public showOutletAcquisitionType: boolean;
    @Input() public showProspectSource: boolean;
    

    @Input() public requireSubtradeChannel: boolean;
    @Input() public requireBusinessType: boolean;
    @Input() public requireCustomerNumber: boolean;
    @Input() public requireOldZRPartnerEmployee: boolean;
    @Input() public requireOldZKPartnerEmployee: boolean;
    @Input() public requireReportingHierarchyEmployee: boolean;
    @Input() public requireEmployee: boolean;
    @Input() public requireBusinessName: boolean;
    @Input() public requireLegalName: boolean;
    @Input() public requireVendingMachineLocation: boolean;
    @Input() public requireMobilePhone: boolean;
    @Input() public requireOverallAccountPhoneNumber: boolean;
    @Input() public requireEmail: boolean;
    @Input() public requireCustomerOwnership: boolean;
    @Input() public requireCustomerType: boolean;
    @Input() public requireNewBusinessName: boolean;
    @Input() public requireNewLegalName: boolean;
    @Input() public requireOutletAcquisitionType: boolean;
    @Input() public requireProspectSource: boolean;

    contactValidations: ent.ContactValidation[] = [];

    items: FormArray;
    setDates() { }

    showOverrideEmployeeLabel(): boolean {
        return this.overrideEmployeeLabel && this.overrideEmployeeLabel != "";
    }

    setRequestInfo(request: ent.Request) {
        this.generalInfo = request.GeneralInfo;
        this.request = request;
        

        if (this.generalInfo.OldZRPartnerEmployeeID == null) { this.generalInfo.OldZRPartnerEmployeeID = Constants._NONE };
        if (this.generalInfo.EmployeeID == null) { this.generalInfo.EmployeeID = Constants._NONE };
        if (this.generalInfo.ReportingHierarchyEmployeeID == null) { this.generalInfo.ReportingHierarchyEmployeeID = Constants._NONE };

        this.includeSurveyRequestChange(this.generalInfo.IncludeSurveyRequest);
        this.includeEquipmentInstallChange(this.generalInfo.IncludeEquipmentInstall);
        this.includeOwnershipChangeChange(this.generalInfo.IncludeOwnershipChange);

        this.setEmployeeAutoCompleteValue(this.employeeAutoCompleteComponent, this.generalInfo.EmployeeID);
        this.setEmployeeAutoCompleteValue(this.oldZRPartnerEmployeeAutoCompleteComponent, this.generalInfo.OldZRPartnerEmployeeID);
        this.setEmployeeAutoCompleteValue(this.oldZKPartnerEmployeeAutoCompleteComponent, this.generalInfo.OldZKPartnerEmployeeID);
        this.setEmployeeAutoCompleteValue(this.reportingHierarchyEmployeeAutoCompleteComponent, this.generalInfo.ReportingHierarchyEmployeeID);

        if (this.requestCustomerGridComponent) {
            this.requestCustomerGridComponent.lineItems = [];
            for (var lineItem of request.RequestCustomers) {
                this.requestCustomerGridComponent.lineItems.push(lineItem);
            }
        }

        if (this.generalInfo.IncludeOwnershipChange) {
            if (this.generalInfo.SerialNumbers) {
                this.serialNumbers = [];
                for (var item of this.generalInfo.SerialNumbers) {
                    this.serialNumbers.push({ SerialNumber: item })
                }
            }
        }

        this.populateCustomerAutoComplete(this.customerAutoCompleteComponent, request);
        this.populateCustomerAutoComplete(this.customersAutoCompleteComponent, request);

        if (this.existingCustomerAutoCompleteComponent) {
            this.existingCustomerAutoCompleteComponent.customers = [];
            this.existingCustomerAutoCompleteComponent.selectedCustomerNumbers = [];

            var filter: filters.CustomerFilter = { CustomerNumber: request.GeneralInfo.ExistingCustomerNumber };
            this.customerService.getCustomers(filter).subscribe(x => {
                if (x && x.length > 0) {
                    var cust = x[0];
                    this.existingCustomerAutoCompleteComponent.customersModel = { name: cust.FullName, ID: cust.CustomerNumber };
                }
            });
        }

        if (this.willCustomerSellDrPepperDropdownComponent) {
            if (this.generalInfo.WillCustomerSellDrPepper == null) {
                this.willCustomerSellDrPepperDropdownComponent.value = Constants._NONE;
            } else if (this.generalInfo.WillCustomerSellDrPepper == true) {
                this.willCustomerSellDrPepperDropdownComponent.value = Constants._YES;
            } else {
                this.willCustomerSellDrPepperDropdownComponent.value = Constants._NO;
            }
        }
    }

    populateCustomerAutoComplete(ac: CustomersAutoCompleteComponent, request: ent.Request) {
        if (ac) {
            ac.customers = [];
            ac.selectedCustomerNumbers = [];
            if (ac.multiple) {
                if (request.RequestCustomers) {
                    for (var requestCustomer of request.RequestCustomers.filter(x => x.RequestCustomerTypeID == enums.RequestCustomerTypeEnum.ZRPartnerUpdate)) {
                        ac.customers.push({ name: requestCustomer.Customer.FullName, ID: requestCustomer.Customer.CustomerNumber });
                        ac.selectedCustomerNumbers.push(requestCustomer.Customer.CustomerNumber);
                        ac.customersModel = this.customersAutoCompleteComponent.customers;
                    }
                }
            }
            else {
                var filter: filters.CustomerFilter = { CustomerNumber: request.GeneralInfo.CustomerNumber };
                this.customerService.getCustomers(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        var cust = x[0];
                        ac.customersModel = { name: cust.FullName, ID: cust.CustomerNumber };

                        this.customerNumberChanged.emit(request.GeneralInfo.CustomerNumber);
                        this.selectedCustomer = cust;
                    }

                });
            }
        }
    }


    setEmployeeAutoCompleteValue(component: EmployeesAutoCompleteComponent, employeeID?: number) {
        if (component) {
            component.employees = [];
            component.selectedEmployeeNumbers = [];


            if (employeeID) {
                var filter: filters.EmployeeFilter = { EmployeeID: employeeID };
                this.employeeService.getEmployees(filter).subscribe(x => {
                    if (x && x.length > 0) {
                        var employee = x[0];
                        component.employeesModel = { name: employee.FullNameWithPersonnelNumber, ID: employee.ID };
                    }

                });
            }
        }
    }

    constructor(fb: FormBuilder, private customerService: serv.CustomerService, private equipmentService: serv.EquipmentService) {
        super();
        this.generalInfo = new ent.GeneralInfo();
        let group = {
            'customerNumber': '',
            'customerAutoSelect': '',
            'hidCustomerNumber': '',
            'businessName': '',
            'oldZRPartnerEmployee': '',
            'hidOldZRPartnerEmployee': '',
            'hidOldZKPartnerEmployee': '',
            'employee': '',
            'hidEmployee': '',
            'reportingHierarchyEmployee': '',
            'hidReportingHierarchyEmployee': '',
            'storeNumber': '',
            'legalName': '',
            'vendingMachineLocation': '',
            'language': '',
            'overallAccountPhoneNumber': '',
            'fax': '',
            'email': '',
            'cma': '',
            'projectNumber': '',
            'subtradeChannel': '',
            'hidSubtradeChannel': '',
            'businessType': '',
            'hidBusinessType': '',
            'includeEquipmentInstall': '',
            'includeSurveyRequest': '',
            'customerType': '',
            'hidCustomerType': '',
            'includeOwnershipChange': '',
            'changeCustomerToSecondaryVolume': '',
            'existingCustomerNumber': '',
            'hidExistingCustomerNumber': '',
            'willCustomerSellDrPepper': '',
            'allCustomers': '',
            'newBusinessName': '',
            'newLegalName': '',
            'outletAcquisitionType': '',
            'hidOutletAcquisitionType': '',
            'prospectSource': '',
            'hidProspectSource': ''
            
        };

        this.generalDetailsForm = fb.group(group);

    }


    customerNumberChange(event: any): void {
        this.customerNumberChanged.emit(event);
    }
    ngOnInit(): void {

        this.domainDataService.getContactValidations({ IncludeInactive: false }).subscribe(x=>{
            this.contactValidations = x;
            
            var emailValidators = [emailValidatorWithParameters(this.contactValidations), emailValidator];
            var overallAccountPhoneNumberValidators = [phoneNumberValidatorWithParameters(this.contactValidations)];
            
            if(this.requireEmail) {
                emailValidators.push(Validators.required);
            }
            
            if (this.requireOverallAccountPhoneNumber) {
                overallAccountPhoneNumberValidators.push(phoneRequiredValidator);
            }
            
            this.generalDetailsForm.controls['email'].setValidators(emailValidators);
            this.generalDetailsForm.controls['overallAccountPhoneNumber'].setValidators(overallAccountPhoneNumberValidators);

            this.generalDetailsForm.controls['email'].updateValueAndValidity()
            this.generalDetailsForm.controls['overallAccountPhoneNumber'].updateValueAndValidity()

            this.generalDetailsForm.controls['fax'].setValidators(phoneNumberValidatorWithParameters(this.contactValidations));
            
        });

        if (this.generalInfo.OldZRPartnerEmployeeID == null) { this.generalInfo.OldZRPartnerEmployeeID = Constants._NONE };
        if (this.generalInfo.EmployeeID == null) { this.generalInfo.EmployeeID = Constants._NONE };
        if (this.generalInfo.ReportingHierarchyEmployeeID == null) { this.generalInfo.ReportingHierarchyEmployeeID = Constants._NONE };

        if (this.requireCustomerNumber) {
            if (this.customerLookupsEnabled()) {
                this.generalDetailsForm.controls['hidCustomerNumber'].setValidators(Validators.required);
            }
            else {
                this.generalDetailsForm.controls['customerNumber'].setValidators(Validators.required);
            }
        }

        if (this.requireBusinessName) {
            this.generalDetailsForm.controls['businessName'].setValidators(Validators.required);
        }

        if (this.requireNewBusinessName) {
            this.generalDetailsForm.controls['newBusinessName'].setValidators(Validators.required);
        }

        if (this.requireOldZRPartnerEmployee) {
            this.generalDetailsForm.controls['hidOldZRPartnerEmployee'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireEmployee) {
            this.generalDetailsForm.controls['hidEmployee'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireReportingHierarchyEmployee) {
            this.generalDetailsForm.controls['hidReportingHierarchyEmployee'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireLegalName) {
            this.generalDetailsForm.controls['legalName'].setValidators(Validators.required);
        }

        if (this.requireNewLegalName) {
            this.generalDetailsForm.controls['newLegalName'].setValidators(Validators.required);
        }

        if (this.requireVendingMachineLocation) {
            this.generalDetailsForm.controls['vendingMachineLocation'].setValidators(Validators.required);
        }        

        if (this.requireSubtradeChannel) {
            this.generalDetailsForm.controls['subtradeChannel'].setValidators(dropDownValidator);
            this.generalDetailsForm.controls['hidSubtradeChannel'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireBusinessType) {
            this.generalDetailsForm.controls['businessType'].setValidators(dropDownValidator);
            this.generalDetailsForm.controls['hidBusinessType'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireCustomerType) {
            this.generalDetailsForm.controls['customerType'].setValidators(dropDownValidator);
            this.generalDetailsForm.controls['hidCustomerType'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireOutletAcquisitionType) {
            this.generalDetailsForm.controls['outletAcquisitionType'].setValidators(dropDownValidator);
            this.generalDetailsForm.controls['hidOutletAcquisitionType'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.requireProspectSource) {
            this.generalDetailsForm.controls['prospectSource'].setValidators(dropDownValidator);
            this.generalDetailsForm.controls['hidProspectSource'].setValidators(hiddenDropDownValueValidator);
        }

        if (this.generalInfo.IncludeOwnershipChange) {
            this.generalDetailsForm.controls.existingCustomerNumber.setValidators(Validators.required);
        }
    }

    willCustomerSellDrPepperLoadDone(event: any) {
        if (this.willCustomerSellDrPepperDropdownComponent && !this.request) {
            var setting = this.userInfo.AppSettings.filter(x => x.ID == enums.AppSettingEnum.WillCustomerSellDrPepperDefaultVallue)[0];
            if (setting) {
                if (setting.SettingValue == "YES") {

                    this.willCustomerSellDrPepperDropdownComponent.value = Constants._YES;
                }
                else if (setting.SettingValue == "NO") {

                    this.willCustomerSellDrPepperDropdownComponent.value = Constants._NO;
                }
            }
        }
    }

    ngAfterViewInit() {

        this.oldZRPartnerEmployeeAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[0];
        this.employeeAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[1];
        this.oldZKPartnerEmployeeAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[2];
        this.reportingHierarchyEmployeeAutoCompleteComponent = this.employeesAutoCompleteComponents.toArray()[3];

        

    }

    showCustomerNumberInfoLabel(): boolean {
        return this.customerNumberInfoLabel && this.customerNumberInfoLabel != "";
    }

    //#region Drop Down Selected events
    subtradeChannelSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.subtradeChannel.errors && form.controls.hidSubtradeChannel.errors) {
            if (form.controls.subtradeChannel.errors.invalid && form.controls.hidSubtradeChannel.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    businessTypeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.businessType.errors && form.controls.hidBusinessType.errors) {
            if (form.controls.businessType.errors.invalid && form.controls.hidBusinessType.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    customerTypeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.customerType.errors && form.controls.hidCustomerType.errors) {
            if (form.controls.customerType.errors.invalid && form.controls.hidCustomerType.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    outletAcquisitionTypeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.outletAcquisitionType.errors && form.controls.hidOutletAcquisitionType.errors) {
            if (form.controls.outletAcquisitionType.errors.invalid && form.controls.hidOutletAcquisitionType.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    prospectSourceSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.prospectSource.errors && form.controls.hidProspectSource.errors) {
            if (form.controls.prospectSource.errors.invalid && form.controls.hidProspectSource.errors.invalid) {
                val = false;
            }
        }
        return val;
    }
    //#endregion

    //#region Employee Drop Down Selected events
    employeeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.hidEmployee.errors) {
            if (form.controls.hidEmployee.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    oldZRPartnerEmployeeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.hidOldZRPartnerEmployee.errors) {
            if (form.controls.hidOldZRPartnerEmployee.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    oldZKPartnerEmployeeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.hidOldZKPartnerEmployee.errors) {
            if (form.controls.hidOldZKPartnerEmployee.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    reportingHierarchyEmployeeSelected() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.hidReportingHierarchyEmployee.errors) {
            if (form.controls.hidReportingHierarchyEmployee.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    //#endregion

    //#region Employee Auto Complete Changed Events
    oldZRPartnerEmployeesChanged(employeeIDs: number[]) {
        if (employeeIDs && employeeIDs.length > 0) {
            this.generalInfo.OldZRPartnerEmployeeID = employeeIDs[0];
        }
        else {
            this.generalInfo.OldZRPartnerEmployeeID = Constants._NONE;
        }
    }

    oldZKPartnerEmployeesChanged(employeeIDs: number[]) {
        if (employeeIDs && employeeIDs.length > 0) {
            this.generalInfo.OldZKPartnerEmployeeID = employeeIDs[0];
        }
        else {
            this.generalInfo.OldZKPartnerEmployeeID = Constants._NONE;
        }
    }

    employeesChanged(employeeIDs: number[]) {
        if (employeeIDs && employeeIDs.length > 0) {
            this.generalInfo.EmployeeID = employeeIDs[0];
        }
        else {
            this.generalInfo.EmployeeID = Constants._NONE;
        }
    }

    reportingHierarchyEmployeesChanged(employeeIDs: number[]) {
        if (employeeIDs && employeeIDs.length > 0) {
            this.generalInfo.ReportingHierarchyEmployeeID = employeeIDs[0];
        }
        else {
            this.generalInfo.ReportingHierarchyEmployeeID = Constants._NONE;
        }
    }

    //#endregion

    //#region Drop Down Change Events
    subtradeChannelChange(event: any) {
        this.generalInfo.SubtradeChannelID = event;
    }

    businessTypeChange(event: any) {
        this.generalInfo.BusinessTypeID = event;
        this.businessTypeChanged.emit(event);
    }

    includeSurveyRequestChange(checked: boolean) {

        this.includeSurveyRequestChanged.emit(checked);

    }

    includeEquipmentInstallChange(checked: boolean) {

        this.includeEquipmentInstallChanged.emit(checked);
        this.disableOwnershipChange = checked;
    }

    allCustomersChange(checked: boolean) {
        this.disableCustomersAutocomplete = checked;
    }

    includeOwnershipChangeChange(checked: boolean) {
        if (this.requestTypeID == enums.RequestTypeEnum.MaintainCustomer) {
            return;
        }
        this.generalDetailsForm.controls.existingCustomerNumber.clearValidators();
        if (checked) {
            this.generalDetailsForm.controls.existingCustomerNumber.setValidators(Validators.required);
        }
        this.generalDetailsForm.controls.existingCustomerNumber.updateValueAndValidity();
        this.includeOwnershipChangeChanged.emit(checked);
        this.disableEquipmentInstall = checked;

    }

    customerTypeChange(event: any) {
        this.generalInfo.CustomerTypeID = event;
        this.customerTypeChanged.emit(event);
    }

    outletAcquisitionTypeChange(event: any) {
        this.generalInfo.OutletAcquisitionTypeID = event;
    }

    prospectSourceChange(event: any) {
        this.generalInfo.ProspectSourceID = event;
    }
    //#endregion


    showOwnershipChangeDetails(): boolean {
        if (this.requestTypeID == enums.RequestTypeEnum.MaintainCustomer) {
            return false;
        }
        return this.generalInfo.IncludeOwnershipChange;
    }


    emailValid() {
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls.email.errors) {
            if (form.controls.email.errors.invalid) {
                val = false;
            }
        }
        return val;
    }

    isFieldValid(fieldName: string){
        var val = true;
        var form = this.generalDetailsForm;
        if (form.controls[fieldName].errors){
            if (form.controls[fieldName].errors.invalid){
                val = false;
            }
        }
        return val;
    }

    getCustomError(fieldName: string) : string{
        
        if (!this.isFieldValid(fieldName)) {
            return "";
        }
        var form = this.generalDetailsForm;
        if (form.controls[fieldName].errors){
            if (form.controls[fieldName].errors.customError){
                return form.controls[fieldName].errors.customError;
            }
        }
        return "";
    }

    getPayer() : string {
        if (this.selectedCustomer && this.selectedCustomer.PYPayerNumber && this.selectedCustomer.PayerName) {
            return `${this.selectedCustomer.PYPayerNumber} - ${this.selectedCustomer.PayerName}`;
        }
        return "";
    }

    getSalesOffice() : string {
        if (this.selectedCustomer && this.selectedCustomer.SalesOfficeID) {
            return `${this.selectedCustomer.SalesOfficeNumber} - ${this.selectedCustomer.SalesOfficeName}`;
        }
        return "";
    }

    selectedCustomerNumbersChanged(customerNumbers: string[]) {
        this.customerTypeDropdownComponent.value = Constants._NONE;
        this.selectedCustomer = {};
        if (customerNumbers && customerNumbers.length > 0) {
            var filter: filters.CustomerFilter = { CustomerNumber: customerNumbers[customerNumbers.length - 1] };
            this.customerService.getCustomers(filter).subscribe(x => {
                if (x && x.length > 0) {
                    this.generalInfo.CustomerNumber = x[0].CustomerNumber;
                    this.generalInfo.BusinessName = x[0].Name;
                    this.customerTypeDropdownComponent.value = x[0].CustomerTypeId;
                    this.selectedCustomer = x[0];
                    
                }
                else {
                    this.generalInfo.CustomerNumber = "";
                    this.generalInfo.BusinessName = "";
                }
                this.customerNumberChanged.emit(this.generalInfo.CustomerNumber);

            });
        }
        else {
            this.generalInfo.CustomerNumber = "";
            this.generalInfo.BusinessName = "";
            this.customerNumberChanged.emit(this.generalInfo.CustomerNumber);
        }

    }

    selectedExistingCustomerNumbersChanged(customerNumbers: string[]) {
        if (customerNumbers && customerNumbers.length > 0) {
            var filter: filters.CustomerFilter = { CustomerNumber: customerNumbers[customerNumbers.length - 1] };
            this.customerService.getCustomers(filter).subscribe(x => {
                if (x && x.length > 0) {
                    this.generalInfo.ExistingCustomerNumber = x[0].CustomerNumber;
                    this.getEquipment(this.generalInfo.ExistingCustomerNumber);
                }
                else {
                    this.generalInfo.ExistingCustomerNumber = "";
                    this.serialNumbers = [];
                }
            });
        }
        else {
            this.generalInfo.ExistingCustomerNumber = "";
            this.serialNumbers = [];
        }
    }

    getEquipment(customerNumber: string) {

        var filter: filters.EquipmentFilter = { CustomerNumber: customerNumber };
        this.equipmentService.getEquipments(filter).subscribe(x => {
            this.serialNumbers = [];
            for (var equip of x) {
                var newLineItem: ent.SerialNumber = { SerialNumber: equip.EquipmentNumber };
                this.serialNumbers = [...this.serialNumbers, newLineItem];
            }
        });
    }

    businessTypeLoadDone(event: any) {
        this.onBusinessTypeLoadDone.emit(event);
    }

    onAddSerialNumberClick() {
        if (!this.serialNumbers) { this.serialNumbers = [] }
        var newLineItem: ent.SerialNumber = { SerialNumber: "" };

        this.serialNumbers = [...this.serialNumbers, newLineItem];
    }

    onDeleteSerialNumberClick(event: any, lineItem: ent.SerialNumber) {
        this.serialNumbers = _.remove(this.serialNumbers, x => x.SerialNumber !== lineItem.SerialNumber);
    }

    willCustomerSellDrPepperChange(event: any) {
        if (event == Constants._NONE) {
            this.generalInfo.WillCustomerSellDrPepper = null;
        }
        else if (event == Constants._YES) {
            this.generalInfo.WillCustomerSellDrPepper = true;
        } else {
            this.generalInfo.WillCustomerSellDrPepper = false;
        }

    }

    showWillCustomerSellDrPepperRequiredValidator(): boolean {
        return this.generalInfo.WillCustomerSellDrPepper === null;
    }

}
